import { Severity } from 'enums/Severity';
import { SLAEventLabel } from 'enums/SLAEventLabel';
import { SLAEventPhase } from 'enums/SLAEventPhase';
import { AnalyticsAdapter } from 'interfaces/AnalyticsAdapter';
import { AnalyticsAction, AnalyticsActionEx, AnalyticsService } from 'services/AnalyticsService';
import { getActionName } from 'utils/analytics';

import { services } from '../container';
import { ServiceConfiguration } from '../ServiceConfiguration';

/** @deprecated */
const routeLabelMap: Record<string, string> = {
    '': 'Главная',
    main: 'Главная',
    payments: 'Платежи и переводы',
    transfers: 'Платежи и переводы',
    references: 'Справки',
    history: 'История',
    my_products: 'Продукты',
    products: 'Продукты',
    search: 'Поиск',
};

export class AnalyticsServiceImpl implements AnalyticsService {
    private _adapter: AnalyticsAdapter = null;

    configure({ widgetParameters: { analyticsAdapter } }: ServiceConfiguration): void {
        this._adapter = analyticsAdapter ?? null;
    }

    send(action: AnalyticsAction) {
        if (this._adapter) {
            this._adapter.sendAnalytics({
                analyticsAction: action,
                rumAction: { actionName: getActionName(action) },
            });
            services.log.info(`Analytics sent: ${JSON.stringify(action)}`, Severity.VeryLow);
        } else {
            services.log.warn(
                `Failed to send analytics (no active adapter): ${JSON.stringify(action)}`,
                Severity.VeryLow,
            );
        }
    }

    /** @deprecated */
    getTabPath(tab?: string) {
        const route = window.location.pathname.slice(1).split('/')[0];
        return ['ВТБ-Онлайн', routeLabelMap[route] ?? route, 'Чат с банком', tab]
            .filter(Boolean)
            .join(' | ');
    }

    /** @deprecated */
    private _send(action: AnalyticsActionEx) {
        if (this._adapter) {
            const payload = JSON.stringify(action);
            const message = `The deprecated method of sending analytics is called with an action: ${payload}`;
            services.log.warn(message, Severity.VeryLow);
        }
    }

    /** @deprecated */
    sendAnalyticsSLAEvent(label: SLAEventLabel, phase: SLAEventPhase, custom_fields?: unknown) {
        this._send({
            type: 'event',
            payload: {
                action: phase,
                label,
                category: 'SLAEvent',
                custom_fields,
            },
        });
    }

    /** @deprecated */
    sendAnalyticsAction(action: string, label = 'Чат с банком', ...category: string[]) {
        this._send({
            type: 'event',
            payload: {
                action,
                category: this.getTabPath((category ?? []).join(' | ')),
                label,
            },
        });
    }

    /** @deprecated */
    sendScreenViewEvent(title: string, ...path: string[]) {
        this._send({
            type: 'pageview',
            payload: {
                title,
                path: this.getTabPath((path ?? []).join(' | ')),
            },
        });
    }
}
